import t from "./_arrayPush.js";
import F from "./_isFlattenable.js";
var e = t, g = F;
function l(i, o, a, b, n) {
  var h = -1, m = i.length;
  for (a || (a = g), n || (n = []); ++h < m; ) {
    var f = i[h];
    o > 0 && a(f) ? o > 1 ? l(f, o - 1, a, b, n) : e(n, f) : b || (n[n.length] = f);
  }
  return n;
}
var s = l;
export {
  s as default
};
//# sourceMappingURL=_baseFlatten.js.map
